<template>
  <div class="modal open_modal" data-modal="modal">
    <div class="modal_overlay" data-modal-close="modal"></div>
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="d_flex_btwn">
          <h3>Email attachment</h3>
          <span>
            <button
              class="btn btn_primary mr_20"
              @click.prevent="downloadFile(filePath)"
            >
              Download
            </button>
            <span
              data-modal-close="modal"
              class="close_icon close_icon_md"
              @click.prevent="closeModal"
            ></span>
          </span>
        </div>
      </div>
      <div class="modal_inner">
        <div class="modal_content modal_1080p">
          <div class="row m_0 p_0">
            <div class="col_12">
              <div class="list_item_popup_img">
                <template
                  v-if="
                    ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(fileExtension)
                  "
                >
                  <img :src="filePath" alt="filePath" class="width_full" />
                </template>
                <template v-if="['pdf'].includes(fileExtension)">
                  <embed :src="filePath" class="width_full" height="500" />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer-file-modal',
  props: {
    showSendMailModal: {
      type: Boolean,
      default: false,
    },
    filePath: {
      type: String,
      required: true,
    },
    original_file_name: {
      type: String,
      required: true,
    },
  },
  computed: {
    fileExtension() {
      return this.filePath.split('.').pop();
    },
  },
  methods: {
    downloadFile(filePath) {
      const a = document.createElement('a');
      a.href = filePath;
      // let filenameArr  = filePath.split('/');
      // let filename = filenameArr[filenameArr.length-1];
      // a.download = filename;
      a.download = this.original_file_name;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped>
.color_blue {
  color: #3c74e7 !important;
}
</style>
